import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import type {Context} from 'src/common/types'
import {PricingSectionDefault} from './variations/Default'
import {PricingSectionLarge} from './variations/Large'
import {PricingSectionModulesAndAddons} from './variations/ModulesAndAddons'

/**
 * Props for `PricingSection`.
 */
export type PricingSectionProps = SliceComponentProps<Content.PricingSectionSlice> & {context: Context}

/**
 * Component for "PricingSection" Slices.
 */
const PricingSection = ({
  slice,
  index: componentIndex,
  context: {pageUid, buttonsData},
}: PricingSectionProps): JSX.Element | null => {
  switch (slice.variation) {
    case 'default':
    case 'reskin':
      return <PricingSectionDefault slice={slice} context={{pageUid, buttonsData}} componentIndex={componentIndex} />

    case 'large':
      return <PricingSectionLarge slice={slice} pageUid={pageUid} componentIndex={componentIndex} />

    case 'modulesAndAddons':
      return (
        <PricingSectionModulesAndAddons
          slice={slice}
          pageUid={pageUid}
          componentIndex={componentIndex}
          buttonsData={buttonsData}
        />
      )

    default:
      return null
  }
}

export default PricingSection
